// extracted by mini-css-extract-plugin
export default {"menu":"K7NC9C","menuItem":"ehN5mR","icon":"CIbKMt","login":"GyLSaK","home":"FOp_sJ","gift":"ZsIRdj","bgm":"zOTpAD","off":"eM3GFB"};